import(/* webpackMode: "eager", webpackExports: ["Slot"] */ "/app/node_modules/@radix-ui/react-slot/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/components/Policies.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/components/rooms/hotelRooms.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/Dates.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/Facilities.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/HotelBill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/hotelDetailsBill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/HotelMapSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/hotelOverview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/HotelRedirectButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/MainPrice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/MobileHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/NavigateToSearchPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/recommended/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/profile/(with-container)/(sidebar-layout)/refer/CopierButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/favouriteButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/NextLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ScrollToButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ShareButton.tsx.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Gallery.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/utils/LazyLoadWrapper.tsx");
